import { Component, computed, input } from '@angular/core';
import { IconProperties, IconTypes } from './icon-properties.model';

@Component({
    selector: 'topo-icon',
    imports: [],
    templateUrl: './icon.component.html',
    styleUrl: './icon.component.scss'
})
export class IconComponent {
  protected props = input<IconProperties>();
  protected IconTypes = IconTypes;

  protected type = computed(() => this.props()?.type ?? IconTypes.SystemIcon);
  protected path = computed(() => this.props()?.path);
  protected style = computed(() => this.props()?.style);
}
